import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import useMobile from '../../../shared/hooks/useMobile';
import useHaveClubPeque from '../../../shared/hooks/useHaveClubPeque'
import './section-presentations.scss';

const SectionPresentations = ({ contentInfo, productStage, setProductStage }) => {

    const mobile = useMobile();
    const [currentSlide, setCurrenSlide] = useState(0)
    const {haveClubPeque} = useHaveClubPeque()
    
    const options = {
        renderNode: {
            [BLOCKS.HEADING_2]: (node, next) => <h2 className="f-m-presentations__title">{next}</h2>,
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-presentations__description">{next}</p>
        }
    };

    const getPresentationsCards = () => {
        if (contentInfo.etapasDelProducto && contentInfo.etapasDelProducto[productStage].presentacionesDelProducto) {

            const presentationList = contentInfo.etapasDelProducto[productStage].presentacionesDelProducto.map((info, index) => {
                return (
                    <div key={index}
                        className="f-m-presentations__single-card">
                        <div className="f-m-presentations__card">
                            <div className="f-m-presentations__card-content">
                                {info.imagenDeLaPresentacion &&
                                    <GatsbyImage
                                        image={info.imagenDeLaPresentacion.gatsbyImageData}
                                        alt={info.imagenDeLaPresentacion.description}
                                        className="f-m-presentations__card-image"
                                    />
                                }
                                <div className="f-m-presentations__card-info">
                                    <h3 className="f-m-presentations__name">{info.tituloDeLaPresentacion}</h3>
                                    {haveClubPeque && <div>
                                        <p className="f-m-presentations__card-description">Esta presentación te da</p>
                                        <p className="f-m-presentations__points">{info.puntosDeLaPresentacion + " Puntos"}</p>
                                    </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                )
            })

            return presentationList

        } else if (contentInfo.presentacionesDelProducto) {

            const presentationList = contentInfo.presentacionesDelProducto.map((info, index) => {

                return (
                    <div key={index}
                        className="f-m-presentations__single-card">
                        <div className="f-m-presentations__card">
                            <div className="f-m-presentations__card-content">
                                {info.imagenDeLaPresentacion &&
                                    <GatsbyImage
                                        image={info.imagenDeLaPresentacion.gatsbyImageData}
                                        alt={info.imagenDeLaPresentacion.description}
                                        className="f-m-presentations__card-image"
                                    />
                                }
                                <div className="f-m-presentations__card-info">
                                    <h3 className="f-m-presentations__name">{info.tituloDeLaPresentacion}</h3>
                                    {haveClubPeque && <div>
                                        <p className="f-m-presentations__card-description">Esta presentación te da</p>
                                        <p className="f-m-presentations__points">{info.puntosDeLaPresentacion + " Puntos"}</p>
                                    </div>
                                    }
                                    

                                </div>
                            </div>
                        </div>
                    </div>
                )
            })

            return presentationList

        }
    }

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <span
                className={"f-m-slider-presentations-next " + (currentSlide >= (getPresentationsCards().length - 1) ? "__hide" : "")}
                onClick={onClick}
            />
        );
    }
    const PrevArrow = (props) => {
        const { onClick } = props;

        return (
            <span
                className={"f-m-slider-presentations-prev " + (currentSlide === 0 ? "__hide" : "")}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 250,
        draggable: true,
        afterChange: current => setCurrenSlide(current),
        arrows: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />
    }

    return (
        <section className="f-m-presentations">
            <div className="f-m-presentations__content">
                {contentInfo.informacionPresentaciones && contentInfo.informacionPresentaciones.raw && documentToReactComponents(JSON.parse(contentInfo.informacionPresentaciones.raw), options)}
                {contentInfo.etapasDelProducto &&
                    <div className="f-m-presentations__stages-box">
                        <div className="f-m-presentations__stages-container">
                            {
                                contentInfo.etapasDelProducto.map((info, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className={"f-m-presentations__stage-button " + (productStage === index ? "__active" : "")}
                                            onClick={() => {
                                                setProductStage(index)
                                            }}
                                        >
                                            <button>{info.etapa}</button>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                }
                {mobile ?
                    <div className="f-m-presentations__cards-box">
                        <div className="f-m-presentations__cards">
                            {getPresentationsCards()}
                        </div>
                    </div>
                    :
                    <div className="f-m-presentations__slider-container">
                        <Slider {...settings} className="f-m-presentations__slider">
                            {getPresentationsCards()}
                        </Slider>
                    </div>
                }
            </div>
        </section>
    )
}

export default SectionPresentations
